export default "__VITE_ASSET__D_nbL40E__"